<template>
  <TableBodyRow
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr cursor_hover"
    @click="e => $emit('click', e, item)"
  >
    <TableBodyCell
      v-for="ii in [
        { val: item.type, id: 'type' },
        { val: item.stake, id: 'stake' },
        { val: item.rakePercent, id: 'rakePercent' },
        { val: item.rakeCap, id: 'rakeCap' },
        {
          val: item.preflopRakeType ? $t(`solfigr.rake.${item.preflopRakeType}`) : null,
          id: 'preflopRakeType',
        },
      ].filter(i => i && i.val)"
      :key="ii.id"
      :data-tst="`${tstPrefix}_cell_${ii.id}`"
      :thKey="ii.id"
    >
      {{ ii.val }}
    </TableBodyCell>
    <TableBodyCell thKey="actions">
      <div
        class="gw_btn text-medium weight_500 gw_hvr_content"
        style="position: absolute; right: 0.25rem"
        :data-tst="`${tstPrefix}_apply_btn`"
      >
        <div class="mdi mdi-chevron-double-right mr-1"></div>
        {{ $t('btn.apply') }}
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'RakesTableRow',
  components: {
    TableBodyRow,
    TableBodyCell,
  },
  mixins: [table_mix, float_mix],
  props: {
    item: Object,
    thead: Object,
    tstPrefix: String,
  },
  emits: ['click'],
}
</script>
